import React, { FC } from 'react'

import { IconNumber1Props } from './IconNumber1.types'
import * as Styled from './styles/IconNumber1.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNumber1: FC<IconNumber1Props> = ({
  size = nonThemeableRules.defaultSize as number as IconNumber1Props['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconNumber1Props) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M80 0a80 80 0 1 0 80 80A80.09 80.09 0 0 0 80 0zm0 152a72 72 0 1 1 72-72 72.08 72.08 0 0 1-72 72z' />
        <path d='M85.94 40.5a4 4 0 0 0-4.06.11L60.15 54.18A4 4 0 1 0 64.39 61L80 51.21V116a4 4 0 0 0 8 0V44a4 4 0 0 0-2.06-3.5z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconNumber1
